"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { analytics, initPageEngagementTracking } from "@/lib/analytics";

function getRoutePath(pathname: string, searchParams: URLSearchParams) {
  const queryString = searchParams.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
}

export function RouteAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentPath = getRoutePath(pathname, searchParams);
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    previousPathRef.current = currentPath;

    if (!previousPath) {
      analytics.bootstrapAttribution();
    }

    if (previousPath) {
      // GA4 page_view is owned solely by GoogleAnalyticsPageView (it fires on
      // every pathname/searchParams change, including this one). Calling
      // trackPageView here as well double-counted every SPA navigation.
      analytics.pageView(currentPath);
    }

    return initPageEngagementTracking(pathname);
  }, [currentPath, pathname]);

  return null;
}
